/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_CuteInputs */

const fr_rapid_eager_otter_cute = /** @type {(inputs: Rapid_Eager_Otter_CuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors du réabonnement. Veuillez réessayer plus tard.`)
};

/**

* @param {Rapid_Eager_Otter_CuteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_cute = /** @type {((inputs?: Rapid_Eager_Otter_CuteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_CuteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_cute(inputs)
});